let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dSH7z")).then(() => parcelRequire('gJdSk'));